import { Button, Input } from '@otp/ui';
import {
  StoreFilterInput,
  WttpTemplate,
  WttpTemplateAssignToStoresDocument,
  WttpTemplatesDocument,
} from 'src/graphql/generated/graphql';

import { StoresTable } from './table';
import { StoresFilter } from './filter';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';

interface AssignTemplateToStoresProps {
  template: Pick<WttpTemplate, 'id' | 'name'>;
  onClose?: () => void;
}

export const AssignTemplateToStores = (props: AssignTemplateToStoresProps) => {
  const { template, onClose } = props;
  const { t } = useTranslation();

  const [wttpTemplateAssignToStores] = useMutation(
    WttpTemplateAssignToStoresDocument,
    {
      refetchQueries: [WttpTemplatesDocument],
    },
  );

  const [filter, setFilter] = useState<StoreFilterInput>({});
  const [selectedRowIds, setSelectedRowIds] = useState<string[]>([]);

  const onFilterChange = (filter: StoreFilterInput) => setFilter(filter);

  const onRowsSelected = (ids: string[]) => setSelectedRowIds(ids);

  const onSubmit = async () => {
    await wttpTemplateAssignToStores({
      variables: {
        data: {
          storeIds: selectedRowIds,
          templateId: template.id,
        },
      },
    });
    onClose?.();
  };

  return (
    <div className="w-full">
      <Input
        value={template?.name}
        title={t('wttp.template.store-assignment.selected-template')}
        label={t('wttp.template.store-assignment.selected-template')}
      />
      <div className="mt-4">
        <StoresFilter onSubmit={onFilterChange} />
      </div>
      <div className="mt-4">
        <StoresTable
          filter={filter}
          template={template}
          onRowsSelected={onRowsSelected}
          selectedRowIds={selectedRowIds}
        />
      </div>

      <div className="flex justify-end mt-6">
        <Button
          className="mr-2"
          variant="contained"
          color="primary"
          size="medium"
          onClick={onSubmit}
          disabled={!selectedRowIds.length}
        >
          {t('common.assign')}
        </Button>
        <Button variant="outlined" color="primary" onClick={onClose}>
          {t('common.close')}
        </Button>
      </div>
    </div>
  );
};
